var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_413_4048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8H8V4",
    stroke: "#656F7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.99967C14.6666 11.6815 11.6818 14.6663 7.99998 14.6663C4.31808 14.6663 1.33331 11.6815 1.33331 7.99967C1.33331 4.31777 4.31808 1.33301 7.99998 1.33301",
    stroke: "#656F7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.565 2.77995C12.6811 2.88247 12.7941 2.9887 12.9037 3.09834C13.0133 3.20798 13.1194 3.32103 13.2219 3.4372M10 1.33301C10.3214 1.42804 10.6365 1.55057 10.9423 1.69743M14.2917 5.03605C14.4431 5.34843 14.5693 5.67076 14.6667 5.99967",
    stroke: "#656F7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_413_4048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.0f00ffeb989dae02cb317c3cd6aeb424.svg";
export { ForwardRef as ReactComponent };